/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import {KTSVG} from '../../../helpers'

interface Notification {
  title: string;
  message: string;
  type?: 'Info' | 'Warning' | 'Error' | 'Success';
  severity?: number;
  active?: boolean;
  createdAt?: Date;
  link?: string;
}

type Props = {
  className: string;
  notifications: Notification[];
}

const NotificationWidget: React.FC<Props> = ({className, notifications}) => {
  const sortedNotifications = [...notifications].sort((a, b) => (a.severity || Infinity) - (b.severity || Infinity));

  const getNotificationColorClass = (type: Notification['type']) => {
    switch (type) {
      case 'Info':
        return 'bg-light-info';
      case 'Warning':
        return 'bg-light-warning';
      case 'Error':
        return 'bg-light-danger';
      case 'Success':
        return 'bg-light-success';
      default:
        return 'bg-light';
    }
  };

  const getSVGIconClass = (type: Notification['type']) => {
    switch (type) {
      case 'Info':
        return 'svg-icon-info';
      case 'Warning':
        return 'svg-icon-warning';
      case 'Error':
        return 'svg-icon-danger';
      case 'Success':
        return 'svg-icon-success';
      default:
        return 'svg-icon-primary'; // Default icon color
    }
  };

  return (
    <div className={`card ${className}`}>
      {/* begin::Header */}
      <div className='card-header border-0'>
        <h3 className='card-title fw-bolder text-dark'>Notifications</h3>
      </div>
      {/* end::Header */}
      {/* begin::Body */}
      <div className='card-body pt-0 overflow-y-auto' style={{maxHeight: '300px'}}>
        {sortedNotifications.length > 0 ? (
          sortedNotifications.map((notification, index) => (
            <div
              key={index}
              className={`d-flex align-items-center rounded p-5 mb-5 ${getNotificationColorClass(notification.type)}`}
            >
              {/* begin::Icon */}
              <span className={`svg-icon me-5 ${getSVGIconClass(notification.type)}`}>
                <KTSVG path='/media/icons/duotune/abstract/abs027.svg' className='svg-icon-1' />
              </span>
              {/* end::Icon */}
              {/* begin::Title */}
              <div className='flex-grow-1 me-2'>
                <a target='_blank' href={notification.link} className='fw-bolder text-gray-800 text-hover-primary fs-6'>
                  {notification.title}
                </a>
                <span className='text-muted fw-bold d-block'>
                  {notification.message}
                </span>
              </div>
              {/* end::Title */}
              {/* begin::Lable */}
              {notification.createdAt && (
                <span className={`fw-bolder py-1 text-muted text-nowrap`}>
                  {new Date(notification.createdAt).toUTCString()}
                </span>
              )}
              {/* end::Lable */}
            </div>
          ))
        ) : (
          <div className='d-flex align-items-center bg-light rounded p-5'>
            <span className='text-muted fw-bold d-block'>No new notifications</span>
          </div>
        )}
      </div>
      {/* end::Body */}
    </div>
  )
}

export {NotificationWidget}
